import type { Component } from "vue";
import { default as DeleteAccount } from "./delete-account.vue";
import { default as DeliveryAddress } from "./delivery-address.vue";
import { default as Email } from "./email.vue";
import { default as NewEmail } from "./new-email.vue";
import { default as Password } from "./password.vue";
import { default as PersonalDetails } from "./personal-details.vue";
import { default as PhoneNumber } from "./phone-number.vue";

type AccountSettingSectionsList = Array<
  [
    Component,
    {
      requiresProfileDetails: boolean;
      name: string;
    },
  ]
>;

const AccountSettingsSections: AccountSettingSectionsList = [
  [PersonalDetails, { requiresProfileDetails: true, name: "PersonalDetails" }],
  [Email, { requiresProfileDetails: true, name: "Email" }],
  [NewEmail, { requiresProfileDetails: true, name: "NewEmail" }],
  [Password, { requiresProfileDetails: false, name: "Password" }],
  [PhoneNumber, { requiresProfileDetails: true, name: "PhoneNumber" }],
  [DeliveryAddress, { requiresProfileDetails: true, name: "DeliveryAddress" }],
  [DeleteAccount, { requiresProfileDetails: false, name: "DeleteAccount" }],
];
export default AccountSettingsSections;
